import { getParameterByName } from 'helpers/Query';
import appStorage from 'helpers/AppStorage';

const PHRASES_PARAM = 'phrases';
const PHRASES_SHOW_PARAM = 'show';
const PHRASES_TOGGLE_PARAM = 'toggle';
const PHRASES_OFF_PARAM = 'off';
const PHRASES_TOGGLE_APPSTORAGE_KEY = 'showPhraseAppKeyToggle';
export const PHRASES_SHOW_APPSTORAGE_KEY = 'showPhraseAppKeys';

export const getShowPhraseAppKeyToggle = () => {
    const phraseParamValue = getParameterByName(PHRASES_PARAM);
    const phraseToggleShowValue = appStorage(PHRASES_TOGGLE_APPSTORAGE_KEY);
    if (!phraseParamValue && !phraseToggleShowValue) return false;

    if (phraseParamValue === PHRASES_OFF_PARAM) {
        appStorage(PHRASES_TOGGLE_APPSTORAGE_KEY, null);
        appStorage(PHRASES_SHOW_APPSTORAGE_KEY, null);
        return false;
    }
    if (phraseParamValue === PHRASES_SHOW_PARAM) window.showPhraseAppKeys = true;
    else window.showPhraseAppKeys = appStorage(PHRASES_SHOW_APPSTORAGE_KEY) === 'true';

    if (phraseToggleShowValue) return true;
    if ([PHRASES_SHOW_PARAM, PHRASES_TOGGLE_PARAM].includes(phraseParamValue)) {
        appStorage(PHRASES_TOGGLE_APPSTORAGE_KEY, true);
        return true;
    }
    return false;
};

export const parseText = (identifier, options = {}) => {
    if (!identifier) {
        return null;
    }

    let o = identifier;

    if (options.params) {
        Object.keys(options.params).map((key) => {
            o = o.replace('{' + key + '}', options.params[key]);
            return true;
        });
    }

    return o;
};

/**
 * Find text by key path
 * @param {object} object - The object that has all keys (e.g: window.Checkout.text)
 * @param {string} path - Key to find (e.g: dayjs.months). Nested values should be separated by a dot (.)
 */
export const retrieveValue = (object, path) => {
    try {
        return path
            .split('.')
            .reduce(
                (obj, property) => {
                    return obj[property];
                }, object
            );
    } catch (err) {
        return undefined;
    }
};

export const getText = (textKey, options) => {
    if (!textKey) return '';

    const formattedTextKey = textKey.replace('[', '.').replace(']', '');
    const text = retrieveValue(window.Checkout.text, formattedTextKey) || '';
    if (window.showPhraseAppKeys && typeof text !== 'object') return `[${textKey}]`;

    return parseText(text, {
        params: options,
    }) || '';
};
